import { SVGProps } from 'react';
import { ReactComponent } from 'icons/pencil-icon.svg';

/**
 * @deprecated Move to storybook instead
 */
export const PencilIcon = (props: SVGProps<SVGSVGElement>) => {
  return <ReactComponent {...props} />;
};
